export default {"src":"/_next/static/media/early-payment.275fc922.svg","height":432,"width":552};